/**
 * APCWO customisation for OrangeHRM — Email Templates module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */

interface CaretInsertResult {
  value: string;
  caret: number;
}

/**
 * Inserts `snippet` into `current` at the given caret position (falling back to
 * the end of the string). Returns the new value and the caret position that
 * should follow it.
 */
export function insertAtCaret(
  current: string,
  snippet: string,
  caret: number | null,
): CaretInsertResult {
  const value = current || '';
  const len = value.length;
  const at =
    typeof caret === 'number' && caret >= 0 && caret <= len ? caret : len;
  const next = value.slice(0, at) + snippet + value.slice(at);
  return {value: next, caret: at + snippet.length};
}
